import { MenuButtonCombinedProps } from './types';

const usePresenter = (props: MenuButtonCombinedProps): MenuButtonCombinedProps => {
  return props;
};

export default usePresenter;
